import { FormProperty } from './formProperty';

export class FormRow{
    hasRowSpans?: boolean = false;
    properties: FormProperty[]= []
}
